<script setup>
import {computed, onUnmounted, ref, watch} from "vue";
import TabContainer from "@/components/global-themed/tabs/TabContainer.vue";
import TabItem from "@/components/global-themed/tabs/TabItem.vue";
import CompetitorKeywords from "./CompetitorKeywords.vue";
import CompetitorBacklinks from "@/components/competition/partials/CompetitorBacklinks.vue";
import CompetitorHistoric from "@/components/competition/partials/CompetitorHistoric.vue";
import {useStore} from "vuex";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";

const activeTab = ref('keywords');

const store = useStore();

const loading = computed(() => store.getters['competitionV2/loadingCompetitor']);

const requiresRefreshInterval = computed(() => store.getters['competitionV2/isPendingResults'] && !loading.value);

let refreshInterval;

const clearRefreshInterval = () => {
  if (refreshInterval) clearInterval(refreshInterval);
}

watch(requiresRefreshInterval,  (newRequiresRefreshInterval) => {
  clearRefreshInterval();
  if (!newRequiresRefreshInterval) {
    return;
  }

  refreshInterval = setInterval(
    () => store.dispatch('competitionV2/fetchCompetitorDetails', true), 10 * 1000
  );
}, {
  immediate: true,
})

onUnmounted(() => {
  clearRefreshInterval();
})

</script>

<template>
  <div>
    <LoadingBlock v-if="loading" />

    <div v-else>
      <div class="tw-p-8 tw-pb-4">
        <TabContainer>
          <TabItem
            :active="activeTab === 'keywords'"
            class="tw-gap-2 tw-justify-center"
            @click="activeTab = 'keywords'"
          >
            <svg-vue
              icon="icons/rankings"
              class="tw-w-6 tw-h-6"
            />
            <span>Ranking Keywords</span>
          </TabItem>
          <TabItem
            :active="activeTab === 'backlinks'"
            class="tw-gap-2 tw-justify-center"
            @click="activeTab = 'backlinks'"
          >
            <svg-vue
              icon="icons/backlinks"
              class="tw-w-6 tw-h-6"
            />
            <span>Backlinks</span>
          </TabItem>
          <TabItem
            :active="activeTab === 'historic'"
            class="tw-gap-2 tw-justify-center"
            @click="activeTab = 'historic'"
          >
            <svg-vue
              icon="icons/historic"
              class="tw-w-6 tw-h-6"
            />
            <span>Historic</span>
          </TabItem>
        </TabContainer>
      </div>

      <CompetitorKeywords v-if="activeTab === 'keywords'" />

      <CompetitorBacklinks v-if="activeTab === 'backlinks'" />

      <CompetitorHistoric v-if="activeTab === 'historic'" />
    </div>
  </div>
</template>
